<template>
  <div v-if="bkmenu">
    <Header title="菜單編輯" />

    <div class="main">
      <el-tabs v-model="tabIndex" type="card" @tab-click="handleClick">
        <el-tab-pane label="類別" name="mt">
          <Categories />
        </el-tab-pane>
        <el-tab-pane label="餐點" name="mi">
          <Items />
        </el-tab-pane>
        <el-tab-pane label="群組" name="mg">
          <ModifierGroups />
        </el-tab-pane>
        <el-tab-pane label="上傳圖片" name="upload">
          <UploadImage />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<style scoped>
.label {
  font-size: 2rem;
  font-weight: bold;
}

.empty-seat {
  color: #5237eb;
  background-color: white;
}
</style>
<script>
import Categories from "@/components/BKMenu/Tab/Categories";
import Items from "@/components/BKMenu/Tab/Items.vue";
import ModifierGroups from "@/components/BKMenu/Tab/ModifierGroups.vue";
import UploadImage from "@/components/BKMenu/Tab/UploadImage.vue";
import Header from "@/components/BKMenu/BKMenuHeader.vue";
export default {
  components: {
    Categories,
    Items,
    ModifierGroups,
    UploadImage,
    Header,
  },
  data() {
    return {
      bkmenu: null,
      time: "",
      loading: false,
      tabIndex: "mt",
    };
  },
  async mounted() {
    console.log("BKMenu.monted");
    await this.init();
    // this.gLoading();
    // await this.refresh();
    // this.gClear();

    // setInterval(() => {
    //   this.refresh();
    // }, 60 * 1000);
  },
  methods: {
    async init() {
      try {
        var res = await this.apiGetBKMenu();
        this.bkmenu = res.data;
        console.log("bkmenu", this.bkmenu);
      } catch (error) {
        console.log(error.toString());
      }
    },
    handleClick() {},
    add() {},

    async refresh() {
      try {
        this.loading = true;
        var res = await this.apiGetTblinfo();
        this.tblinfo = res.data;
        this.time = this.now();
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    cmdTable(obj) {
      if (obj.minute == null) {
        this.$refs.rOpenTable.show(obj);
      } else {
        this.$refs.rTableInfo.show(obj);
      }
    },
    // async cmdOpenTable(tblname, custtotal) {
    //   try {
    //     this.gLoading();
    //     var query = { tblname: tblname, custtotal: custtotal };
    //     var res = await this.apiOpenTbl(query);
    //     console.log(res);
    //     await this.refresh();
    //     this.$refs.rOpenTable.close();
    //     this.gClear();
    //   } catch (error) {
    //     console.log(error);
    //     this.gClear();
    //   }
    // },
  },
};
</script>
